/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React,{useState} from 'react'
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import GlobalContext from '../../components/Context/GloablContext';
import ErrorMessage from '../../components/ErrorMessage';
import Loader from '../../components/Loader';
import { userService } from '../../services/user.services';
import authSlice from './authSlice';
import BannerImage from './BannerImage'
import { passwordCriteria } from './passwordCriteria'
export default function ResetPassword() {
    const {setToastmessage, setToastErrorMessage} =useContext(GlobalContext)

    const auth = useSelector(state => state.auth);
    const location=useNavigate()
    const [password, setpassword] = useState('');
    const [Newpassword, setNewpassword] = useState('');
    const [autoGeneratedPassword, setautoGeneratedPassword] = useState('');
    const [submitSelected, setsubmitSelected] = useState(false);
    const [type, settype] = useState('password');
    const [btn, setbtn] = useState('password');
    const [AutoType, setAutoType] = useState('password');
    const [loading, setloading] = useState(false)
    const [OverallError, setOverallError] = useState('')
    const [invalidAutoPassword, setinvalidAutoPassword] = useState('')
    
    /**
     * The handleSubmit function is used to handle the form submission for resetting a user's password.
     * @returns The function `handleSubmit` does not return anything.
     */
    const handleSubmit=async(e)=>{
        try{
            e.preventDefault()
            setsubmitSelected(true);
            setOverallError('')
            setloading(true)
            if(autoGeneratedPassword===''||password===''||Newpassword===''){
                setloading(false)
                return;
            }
            const payload={
                "confirm_password":password,
                "new_password": Newpassword,
                "old_password": autoGeneratedPassword
            
            }
            const email = localStorage.getItem('email');
            const endpoint=`users/reset-password/${email}`
            const ResetResponse = await userService.resetPassword(endpoint,payload);
            if(!ResetResponse.error && ResetResponse?.data?.status===204){
                setToastmessage('Your password has been reset successfully');
                localStorage.clear();
                location('/')
            }else{
                if(ResetResponse.message.response.data.message==='Invalid auto-generated password. Please check and try again'){
                    setinvalidAutoPassword(ResetResponse.message.response.data.message)
                }else{
                    setOverallError(ResetResponse.message.response.data.message)
                }
                setloading(false)
            }
        } catch (error){
            setToastErrorMessage('Something went wrong');
            setloading(false)
            localStorage.clear();
            location('/')
        }
    }

    return (
        <div className='flex'>
            <BannerImage />
            <div className="w-1/2 relative">
                <div className="w-full flex flex-col justify-center min-h-screen max-h-max shadow-s1 pb-2">
                    <div className="ml-4 absolute top-[10%] left-0">
                        <a href="/" className="flex items-center backBtnLogin">
                            <span><img src="/images/back-btnBlue.svg" alt="btn" loading="lazy"/></span>
                            <span className="pl-3 text-lg font-medium text-[#106EB4]">Back</span>
                        </a>
                    </div>
                    <img src="/images/SkuTeq-Logo.svg" alt="product-logo" className="mx-auto" loading="lazy"/>
                    {/* <!-- login section --> */}  
                    <div className="login-section mx-auto">
                        <p className="text-center pt-[23px] text-xl font-semibold text-[#031624] resetPassword-errShow">Reset Password</p>
                        <div className="mx-auto">
                            <div className="w-[350px]">
                                <p className="pt-5 text-base text-[#031624] text-center">For security reasons, please reset your auto-generated password before proceeding.</p>
                                <form onSubmit={(e)=>handleSubmit(e)} className="mt-5">
                                    <div className="flex flex-col">
                                        <label for="autoPassWord" className="text-f1 font-medium text-[#344054] pb-1.5">Auto Generated Password</label>
                                        <div className="relative">
                                            <input 
                                                type={AutoType}
                                                onFocus={()=>{
                                                    setsubmitSelected(false);
                                                    setOverallError('')
                                                    setinvalidAutoPassword('')

                                                }}
                                                value={autoGeneratedPassword}
                                                id="autoPassWord" 
                                                style={{border:`1px solid ${submitSelected &&autoGeneratedPassword===''||invalidAutoPassword!==''?'#FDA29B':'#D0D5DD'}`}}
                                                onChange={(e)=>setautoGeneratedPassword(e.target.value)}
                                                className="err-border w-full border border-[#D0D5DD] rounded-lg py-2.5 pl-3.5 pr-[39px] outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#101828]" 
                                                autocomplete="off" 
                                                placeholder="Enter Password" />
                                            <button type="button" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-2">
                                                {AutoType==='text'?<img src="/images/eye-open.svg" loading="lazy" alt="password-show" className="password-show" onClick={()=>setAutoType('password')} />
                                                    :<img src="/images/eye-closed.svg" loading="lazy" alt="password-hide" className="password-show" onClick={()=>setAutoType('text')}/>}
                                            </button>
                                        </div>
                                        <p className="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError hidden">Auto-generated password is mandatory</p>
                                        <p className="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err1 hidden">Invalid auto-generated password. Please check and try again.</p>
                                        {submitSelected &&invalidAutoPassword !=='' && <ErrorMessage 
                                            error 
                                            message={"Invalid auto-generated password. Please check and try again"}
                                            classKey="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError"/>}
                                        {submitSelected &&autoGeneratedPassword ==='' && <ErrorMessage 
                                            error 
                                            message={"Auto-generated password is mandatory"}
                                            classKey="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError"/>}

                                    </div>
                                    <div className="flex flex-col mt-4">
                                        <label for="newPassword" className="text-f1 font-medium text-[#344054] pb-1.5">New Password</label>
                                        <div className="relative">
                                            <input 
                                                type={type}
                                                onChange={(e)=>setpassword(e.target.value)} 
                                                value={password} 
                                                id="newPassword" 
                                                style={{border:`1px solid ${submitSelected &&password===''?'#FDA29B':'#D0D5DD'}`}}
                                                onFocus={()=>{
                                                    setsubmitSelected(false);
                                                    setOverallError('')
                                                    setinvalidAutoPassword('')

                                                }}
                                                className="err-border w-full border border-[#D0D5DD] rounded-lg py-2.5 pl-3.5 pr-[39px] outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#101828]" autocomplete="off" placeholder="Enter Password" />
                                            <button type="button" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-2">
                                                {type==='text'?<img src="/images/eye-open.svg" loading="lazy" alt="password-show" className="password-show" onClick={()=>settype('password')} />
                                                    :<img src="/images/eye-closed.svg" loading="lazy" alt="password-hide" className="password-show" onClick={()=>settype('text')}/>}
                                            </button>
                                        </div>
                                        <p className="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err hidden">New password is mandatory</p>
                                        {submitSelected &&password==='' && <ErrorMessage 
                                            error 
                                            message={"New password is mandatory"}
                                            classKey="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError"
                                        />}
                                        

                                        
                                    </div>
                                    <p className="text-f1 font-normal text-[#667085] pt-1.5">Please make sure your password includes the following:</p>
                                    <ul className="mt-4 pl-2">
                                        {Object.keys(passwordCriteria).map((criteria)=>(
                                            <li className="flex items-center mb-1" key={criteria}>
                                                <span>
                                                    <img src={!passwordCriteria[criteria]["regex"].test(password)?`/images/login-bulletPOint.svg`:`/images/otp-tick.svg`} alt="img" loading="lazy" className="password-weak" id={criteria} />
                                                </span>
                                                <span className="text-f1 font-normal text-[#667085] pl-[11px]"> {criteria}</span>
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="flex flex-col mt-[26px]">
                                        <label for="ConformNewPassword" className="text-f1 font-medium text-[#344054] pb-1.5">Confirm New Password</label>
                                        <div className="relative">
                                            <input 
                                                type={btn} 
                                                onChange={(e)=>setNewpassword(e.target.value)} 
                                                style={{border:`1px solid ${(submitSelected &&Newpassword==='' || Newpassword?.length>0&& Newpassword!==password)?'#FDA29B':'#D0D5DD'}`}}
                                                value={Newpassword}
                                                onFocus={()=>{
                                                    setsubmitSelected(false);
                                                    setOverallError('')
                                                    setinvalidAutoPassword('')

                                                }}
                                                id="ConformNewPassword" 
                                                className="err-border w-full border border-[#D0D5DD] rounded py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#101828]" 
                                                autocomplete="off"
                                                placeholder="Enter Password" />
                                            <button type="button" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-2">
                                                {btn==='text'?<img src="/images/eye-open.svg" loading="lazy" alt="password-show" className="password-show" onClick={()=>setbtn('password')} />
                                                    :<img src="/images/eye-closed.svg" loading="lazy" alt="password-hide" className="password-show" onClick={()=>setbtn('text')}/>}
                                            </button>
                                        </div>
                                    </div>
                                    <p className="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError hidden">Confirm password is mandatory</p>
                                    {submitSelected &&Newpassword==='' && <ErrorMessage 
                                        error 
                                        message={"Confirm password is mandatory"}
                                        classKey="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError"/>}
                                    {Newpassword?.length>0&&password!==Newpassword && <ErrorMessage 
                                        error 
                                        message={"New password and confirm password do not match."}
                                        classKey="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError"
                                    />}
                                    {OverallError!=='' && <ErrorMessage 
                                        error 
                                        message={OverallError}
                                        classKey="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError"
                                    />}
                                    <button 
                                        type="submit"
                                        id="resetpwd-form"
                                        disabled={(password!==Newpassword ||loading)}
                                        className=" flex justify-center items-center w-full bg-[#106EB4] py-3 rounded mt-5 text-f2 font-normal text-[#ffffff] ltr-spcng-8 hover:bg-[#1C8ADC] hover:duration-75">
                                        {!loading?'Reset Password':<span>{<Loader />}</span>}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        
    )
}
